import { Avatar, Stack, Typography } from '@mui/material';

import { selectCurrentUser } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import useLocales from '@src/locales/use-locales';

const AccountInfo = () => {
  const { t } = useLocales();

  const user = useAppSelector(selectCurrentUser);

  const { firstName, lastName, role } = user!;

  const subTitle =
    role === 'ADMIN' ? t('account.administrator') : t('account.user');

  const avatarLetter = firstName?.at(0)?.toUpperCase();

  return (
    <Stack
      direction="row"
      gap={2}
      sx={{
        py: 2,
        px: 2.5,
        mx: 2,
        backgroundColor: 'custom.background',
        borderRadius: 1,
      }}
    >
      <Avatar sx={{ backgroundColor: 'primary.dark', color: 'common.white' }}>
        <Typography
          sx={{
            fontFamily: 'secondaryFontFamily',
            fontSize: '12px',
            fontWeight: 'fontWeightSemiBold',
            color: 'common.white',
          }}
        >
          {avatarLetter}
        </Typography>
      </Avatar>
      <Stack gap={0.5}>
        <Typography
          sx={{ maxWidth: 130 }}
          variant="button"
        >{`${firstName} ${lastName}`}</Typography>
        <Typography
          sx={{
            fontFamily: 'fontFamily',
            fontSize: '12px',
            letterSpacing: 0.15,
            color: 'custom.grey',
          }}
        >
          {subTitle}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default AccountInfo;
